module.exports = __webpack_public_path__ + "static/img/jp_01.bbbd784.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/jp_01.png
// module id = sI3S
// module chunks = 1